<template>
<div class="manager_dashboard">
   <user-menu />
  <div class="wrapper">
    <masteradmin-sidebar-menu />
    <div class="content-wrapper">
      <div class="container-wrapper center">
        <div>
          <h3 class="d-inline heading">Delete User Refresh Token</h3>
        </div>
        <div class="heading-seperator"></div>
        <div class="margin-bottom-10"></div>
        <b-alert
          :show="dangerdismissCountDown"
          dismissible
          variant="danger"
          @dismissed="dangerdismissCountDown=0"
          @dismiss-count-down="countDangerDownChanged"
          >
          {{ error_message }}
        </b-alert>
        <div style="clear: both"></div>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          @dismissed="dismissCountDown=0"
          @dismiss-count-down="countDownChanged"
          >
          {{ success_message }}
        </b-alert>
        <div style="clear: both"></div>
        <div class="search-wrapper col-12">
          <div class="row col-12 override-padding">
            <div class="col-lg-8 col-md-12 col-12">
              <b-form-input
                class="input-text input-height-15"
                v-model="search_username"
                type="text"
                placeholder="Search by Username"
                maxlength="255"
              ></b-form-input>
            </div>
            <div class="col-lg-3 col-md-12">
              <button
                  v-on:click="getUserDetails()"
                  class="btn btn-red btn-md input-height-25 float-left text-align-right"
                  >Search</button>
              <button
                  v-on:click="resetUserDetails()"
                  class="btn btn-red btn-md input-height-25 float-right text-align-right"
                  style="margin-right: 10px;"
                  >Reset</button>
            </div>
          </div>
        </div>
        <div class="margin-bottom-10"></div>
        <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
        <div v-if="(user_details.firstname)">
          <div class="row tasks_heading_row">
            <div class="bold col-xl-3">
              First Name
            </div>
            <div class="bold col-xl-3">
              Last Name
            </div>
            <div class="bold col-xl-4">
              Email
            </div>
            <div class="bold col-xl-2">
              &nbsp;
            </div>
          </div>
          <div class="row tasklist-item" style="margin: 0;">
            <div class="col-xl-3">
              {{ user_details.firstname }}
            </div>
            <div class="col-xl-3">
              {{ user_details.lastname }}
            </div>
            <div class="col-xl-4">
              {{ user_details.email }}
            </div>
            <div class="col-xl-2">
              <button
                  v-on:click="deleteRefreshToken(user_details.id)"
                  class="btn btn-red btn-md input-height-15 float-right text-align-right"
                  >Delete Token</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import adminform from './adminform.vue';
import MasteradminSidebarMenu from '../shared/masteradmin_sidebar_menu.vue';
import axios from 'axios';

export default {
  data: function () {
    return {
      search_username: '',
      user_details: [],
      error_message: '',
      dismissCountDown: 0,
      success_message: '',
      dangerdismissCountDown: 0,
      loading: false,
    }
  },
  components: {
    adminform,
    UserMenu,
    GoBack,
    MasteradminSidebarMenu,
  },
  methods: {
    getUserDetails() {
      this.loading = true;
      axios.get('/user-details/' + this.search_username, {

      })
      .then((resp) => {
        if(resp.data) {
          this.user_details = resp.data;
          this.loading = false;
        }
        else {
          this.error_message = 'Invalid Username.';
          this.dangerdismissCountDown = 5;
          this.loading = false;
          this.search_username = '';
        }
      })
      .catch(error => {

      });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    countDangerDownChanged(dangerdismissCountDown) {
      this.dangerdismissCountDown = dangerdismissCountDown
    },
    resetUserDetails() {
      this.search_username = '';
      this.user_details = [];
    },
    deleteRefreshToken: function(user_id) {
      axios('/delete-user-refresh/' + user_id,
         {
           method: 'DELETE',
         }
       )
      .then((resp) => {
        this.success_message = 'Token Deleted Successfully';
        this.dismissCountDown = 5;
        this.search_username = '';
        this.user_details = [];
       })
      .catch(error => {

      });
    },
  },
}
</script>
<style scoped>
.tasks_heading_row {
  background-color: #8b8b8b;
  line-height: 30px;
  color: #FFF;
  padding: 3px 0px;
  margin-bottom: 0px;
  margin-right: 0px;
  margin-left: 0px;
}
.tasklist-item {
    padding: 12px 0px 12px 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/admin/user_refresh_token_delete.vue